import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import { FaSearch } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { FaUserAlt, FaTruck } from 'react-icons/fa';
import ListaVisita from '../../Componentes/ListaVisita';
import { useNavigate } from "react-router-dom";
import "./styles.css";

const Historico = () => {

  const { IDmotorista } = useParams();
  const [DadosMotorista, setDadosMotorista] = useState([]);
  const [NomeMotorista, setNomeMotorista] = useState('-');
  const [VeiculoMotorista, setveiculoMotorista] = useState('-');
  const [dadosVisitas, setdadosVisitas] = useState([]);
  const [lote, setlote] = useState('');
  const [Todoslote, setTodoslote] = useState('');

  const [ordenacao, setOrdenacao] = useState('nome');
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    }
    carregaDadosMotorista(IDmotorista);
  }, []);

  useEffect(() => {
    carregaListaLotes(IDmotorista);
    carregaListaVisitas(IDmotorista);
  }, [lote]);

  async function carregaDadosMotorista(id) {
    let retorno = await buscaMotorista(id);
    if (retorno) {
      setDadosMotorista(retorno.data);
      setNomeMotorista(
        String(retorno.data.Usuario.IDusuario).padStart(6, '0') +
        '  |  ' + retorno.data.Usuario.pessoa.nome +
        '  |  CPF: ' + formatCPF(retorno.data.Usuario.pessoa.cpf)
      );
      if (retorno.data.Usuario.lote) {
        setlote(retorno.data.Usuario.lote.IDlote);
      }
      if (retorno.data.Usuario.veiculo) {
        setveiculoMotorista(
          retorno.data.Usuario.veiculo[0].modelo +
          ' | ANO: ' + retorno.data.Usuario.veiculo[0].ano_modelo +
          ' | PLACA: ' + retorno.data.Usuario.veiculo[0].placa
        );
      }
    }
  }

  async function carregaListaVisitas(IDmotorista) {
    let retorno = await buscaVisitas(IDmotorista, lote);

    if (retorno && retorno.data && retorno.data.Lote) {
      setdadosVisitas(retorno.data.Lote.resultVisita);
      
    } else {
      console.error("Erro: Dados de visitas não encontrados.");
      setdadosVisitas([]);
    }
  }

  async function carregaListaLotes(IDmotorista) {
    let retorno = await buscaLotes(IDmotorista);

    if (retorno && retorno.data && retorno.data.Lotes) {
      setTodoslote(retorno.data.Lotes);      
    } else {
      console.error("Erro: Dados de visitas não encontrados.");
      setdadosVisitas([]);
    }
  }


  async function buscaVisitas(IDmotorista, Lote) {
    try {
      const response = await api.get('/visitaHistorico/' + IDmotorista + '?lote=' + Lote);
      return response;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  async function buscaLotes(IDmotorista) {
    try {
      const response = await api.get('/loteAllUsuario/' + IDmotorista);
      return response;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  function formatCPF(cpf) {
    cpf = cpf.replace(/\D/g, '');

    if (cpf.length !== 11) {
      return cpf;
    }
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  async function buscaMotorista(id) {
    try {
      const response = await api.get('/usuario/' + id);
      return response;

    } catch (error) {
      console.log(error);
      return error;
    }
  }

  const visitasFiltradas = ordenacao === 'ocorrencia'
    ? dadosVisitas.filter(visita =>
      visita.movimentos && visita.movimentos.some(mov => mov.tipo === 5)
    )
    : dadosVisitas;

  return (
    <div className="menu-container-motorista">
      <MenuLateral />

      <div id="painel_principal_motorista" align="center">
        
       {/* 🔽 ComboBox de Lotes */}
        <div className="row d-flex justify-content-center">
          <div className="form-group" style={{ width: '500px', marginBottom: '20px' }}>
            <label htmlFor="loteSelect" style={{ fontWeight: 'bold', fontSize: '0.9em' }}>
              Selecione a Carga:
            </label>
            <select
              id="loteSelect"
              className="form-control"
              value={lote}
              style={{marginTop:'5px'}}
              onChange={(e) => setlote(e.target.value)}
            >
              <option value="">-- Selecione --</option>
              {Todoslote && Todoslote.length > 0 ? (
                Todoslote.map((item) => (
                  <option key={item.IDlote} value={item.IDlote}>
                    Carga Nº: {item.IDlote} | Data: {new Date(item.datahora).toLocaleDateString("pt-BR")} | Nº Visitas: {item.totalVisitas}
                  </option>
                ))
              ) : (
                <option disabled>Sem lotes disponíveis</option>
              )}
            </select>
          </div>
        </div>

        <br/>

        <h5 style={{ paddingBottom: '0%' }}>Historico De Entregas | Carga nº {lote}</h5>

        <div id="painel_motorista" align="left">
          <div className="row">
  
            <div className="col-sm-10">
              <div>
                <br/>
                <p style={{ fontSize: '0.7em', fontWeight: 'bold' }}> <FaUserAlt /> Motorista:</p>
                <p style={{ fontWeight: 'Normal', marginTop: '-15px', fontSize: '0.9em' }}>
                  {NomeMotorista} 
                </p>
              </div>
            </div>
            <div className="col-sm-2" style={{ paddingLeft: '3%' }}>
              <p style={{ fontSize: '0.7em', marginBottom: '5px' }}><b>LEGENDA :</b></p>
              <div style={{ minHeight: '12px', width: '100px', backgroundColor: '#666', fontSize: '0.6em', color: 'white', padding: '2px', paddingLeft: '7%' }}>
                <div>NÃO VISITADO</div>
              </div>
              <div style={{ minHeight: '12px', width: '100px', marginTop: '2px', backgroundColor: '#c3c366', fontSize: '0.6em', color: 'white', padding: '2px', paddingLeft: '7%' }}>
                <div>EM ANDAMENTO</div>
              </div>
              <div style={{ minHeight: '12px', width: '100px', marginTop: '2px', backgroundColor: '#0a5c0a', fontSize: '0.6em', color: 'white', padding: '2px', paddingLeft: '7%' }}>
                <div>VISITADO</div>
              </div>
              <div style={{ minHeight: '12px', width: '100px', marginTop: '2px', backgroundColor: '#931010', fontSize: '0.6em', color: 'white', padding: '2px', paddingLeft: '7%' }}>
                <div>NÃO ENTREGUE</div>
              </div>
            </div>
          </div>

          <div className="row" style={{ paddingLeft: '0%', color:'black', fontSize:'12px' }}>
            {/* 🔍 Filtro de Ordenação */}
            <div className="col-sm-4 form-group" style={{ width: '15%' }}>
              <label htmlFor="ordenacao" className="form-label" style={{ fontSize: '1.2em' }}>
                Listar:
              </label>
              <select
                className="form-control"
                id="ordenacao"
                value={ordenacao}
                onChange={(e) => setOrdenacao(e.target.value)}
              >
                <option value="nome">Todas</option>
                <option value="ocorrencia">Com Ocorrência</option>
              </select>

            </div>

            <div className="col-sm-2">
            </div>

            <div className="col-sm-2">
    
            </div>

            <div className="col-sm-2">

            </div>

          </div>
          <br/>
        </div>

        <div id="div_painel_motorista">
          <ListaVisita
            listaVisitas={visitasFiltradas}
            listaVisitasReferencia={dadosVisitas}
            idmotorista={IDmotorista}
          />
        </div>

      </div>
    </div>
  );
};

export default Historico;
